export default "__VITE_ASSET__BtG_AUtG__"